module.exports = __webpack_public_path__ + "static/media/signin-user-icon.616f4a84.svg";